import Default from "./CopyToClipboardButton";
export * from "./CopyToClipboardButton";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/CopyToClipboardButton/index.ts